var _defs, _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArena(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "3.2 2.94 57.6 57.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6dccb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a08d6c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdbd9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c8966"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 21.0 L24 21.0 L25 21.0 L26 21.0 L27 21.0 L28 21.0 L29 21.0 L30 21.0 L31 21.0 L32 21.0 L33 21.0 L34 21.0 L35 21.0 L36 21.0 L37 21.1 L38 21.1 L39 21.1 L40 21.1 L41 21.2 L42 21.2 L43 21.3 L44 21.3 L45 21.4 L46 21.5 L47 21.6 L48 21.7 L49 21.8 L50 22.0 L51 22.2 L52 22.4 L53 22.7 L54 23.0 L55 23.4 L56 23.8 L57 24.4 L58 25.3 L59 26.6 L60 34.0 L60 42 L24 42Z",
    fill: "url(#ab)",
    stroke: "#7d6b52",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6a5940"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 27.8 L27.5 25.3 Q28.8 23.4 30.1 25.3 L30.1 27.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9 27.8 L31.9 25.3 Q33.2 23.4 34.5 25.3 L34.5 27.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3 27.9 L36.3 25.4 Q37.6 23.4 38.9 25.4 L38.9 27.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7 28.0 L40.7 25.5 Q42.0 23.6 43.3 25.5 L43.3 28.0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1 28.3 L45.1 25.8 Q46.4 23.9 47.7 25.8 L47.7 28.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 28.9 L49.5 26.4 Q50.8 24.5 52.1 26.4 L52.1 28.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9 30.2 L53.9 27.7 Q55.2 25.8 56.5 27.7 L56.5 30.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 33.8 L27.5 31.3 Q28.8 29.4 30.1 31.3 L30.1 33.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9 33.8 L31.9 31.3 Q33.2 29.4 34.5 31.3 L34.5 33.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3 33.9 L36.3 31.4 Q37.6 29.4 38.9 31.4 L38.9 33.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7 34.0 L40.7 31.5 Q42.0 29.6 43.3 31.5 L43.3 34.0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1 34.3 L45.1 31.8 Q46.4 29.9 47.7 31.8 L47.7 34.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 34.9 L49.5 32.4 Q50.8 30.5 52.1 32.4 L52.1 34.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9 36.2 L53.9 33.7 Q55.2 31.8 56.5 33.7 L56.5 36.2Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14 L10 11.5 L17 11.5 L23 13.5 L27 19 L30 18 L33 25 L38 30 L42 29.5 L46 33 L52 32.5 L60 34 L60 52 Q32 63 4 54Z",
    fill: "url(#ar)",
    stroke: "#7d6b52",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#5e4e3a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8 24.7 L6.8 20.4 Q8.5 17.9 10.2 20.4 L10.2 24.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9 25.9 L12.9 21.7 Q14.7 19.0 16.5 21.7 L16.5 25.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0 26.6 L19.0 22.5 Q20.9 19.6 22.8 22.5 L22.8 26.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 26.9 L25.1 22.9 Q27.1 19.9 29.1 22.9 L29.1 26.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 33.7 L6.8 29.4 Q8.5 26.9 10.2 29.4 L10.2 33.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9 34.9 L12.9 30.7 Q14.7 28.0 16.5 30.7 L16.5 34.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0 35.6 L19.0 31.5 Q20.9 28.6 22.8 31.5 L22.8 35.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 35.9 L25.1 31.9 Q27.1 28.9 29.1 31.9 L29.1 35.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3 36.0 L31.3 32.0 Q33.3 29.0 35.3 32.0 L35.3 36.0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 42.7 L6.8 38.4 Q8.5 35.9 10.2 38.4 L10.2 42.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9 43.9 L12.9 39.7 Q14.7 37.0 16.5 39.7 L16.5 43.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0 44.6 L19.0 40.5 Q20.9 37.6 22.8 40.5 L22.8 44.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 44.9 L25.1 40.9 Q27.1 37.9 29.1 40.9 L29.1 44.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3 45.0 L31.3 41.0 Q33.3 38.0 35.3 41.0 L35.3 45.0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 44.8 L37.5 40.8 Q39.5 37.8 41.5 40.8 L41.5 44.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8 44.3 L43.8 40.2 Q45.7 37.4 47.6 40.2 L47.6 44.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1 43.5 L50.1 39.3 Q51.9 36.6 53.7 39.3 L53.7 43.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 42.0 L56.5 37.6 Q58.1 35.2 59.7 37.6 L59.7 42.0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 51.7 L6.8 47.4 Q8.5 44.9 10.2 47.4 L10.2 51.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9 52.9 L12.9 48.7 Q14.7 46.0 16.5 48.7 L16.5 52.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0 53.6 L19.0 49.5 Q20.9 46.6 22.8 49.5 L22.8 53.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 53.9 L25.1 49.9 Q27.1 46.9 29.1 49.9 L29.1 53.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3 54.0 L31.3 50.0 Q33.3 47.0 35.3 50.0 L35.3 54.0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 53.8 L37.5 49.8 Q39.5 46.8 41.5 49.8 L41.5 53.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8 53.3 L43.8 49.2 Q45.7 46.4 47.6 49.2 L47.6 53.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1 52.5 L50.1 48.3 Q51.9 45.6 53.7 48.3 L53.7 52.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 51.0 L56.5 46.6 Q58.1 44.2 59.7 46.6 L59.7 51.0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArena);
export default __webpack_public_path__ + "static/media/arena.128a00de292fcbba2bc6d007b376a8a4.svg";
export { ForwardRef as ReactComponent };